import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../api/axiosConfig';

const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes (carriers rarely change)

export const fetchCarriers = createAsyncThunk(
  'carriers/fetchCarriers',
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/admin/carriers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      return { data: response.data, timestamp: Date.now() };
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch carriers');
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  error: null,
  lastFetched: null
};

const carrierSlice = createSlice({
  name: 'carriers',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCarriers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCarriers.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.lastFetched = action.payload.timestamp;
      })
      .addCase(fetchCarriers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const selectCarriers = (state) => state.carriers.list;
export const selectCarriersLoading = (state) => state.carriers.loading;
export const selectShouldRefetchCarriers = (state) => {
  if (!state.carriers.lastFetched) return true;
  return Date.now() - state.carriers.lastFetched > CACHE_DURATION;
};

export const { clearError } = carrierSlice.actions;
export default carrierSlice.reducer;
